import React from 'react';
import { Card, ProjectLabel, Stats, Table } from '../../components/ui.jsx';
import { fmtDur } from '../../lib/time.js';
import { canOpenProjectDetail } from '../../lib/detailAccess.js';
import { ReportRangeFilter } from '../../components/reporting/ReportFilters.jsx';
import {
  useReportData,
  useReportFilters,
} from '../../components/reporting/useReportFilters.js';

// The original client-detail body: period filter, effort stats and the
// projects-in-period table. Aggregates existing Time Tracker data across the
// client's projects — unchanged, just lifted into a tab.
export function ClientEffortTab({ client, data, onOpenProject }) {
  const filters = useReportFilters(data, { scope: { clientId: client.id } });
  const { report, loading } = useReportData(filters.query);
  const periodLabel = `${filters.from} to ${filters.to}`;

  return (
    <>
      <ReportRangeFilter {...filters} />
      <Stats
        cards={[
          [
            'Projects in period',
            report.projects.length,
            `${periodLabel}${loading ? ' · Loading...' : ''}`,
          ],
          [
            'Hours in period',
            fmtDur(report.summary.totalHours),
            report.summary.unpaidAbsenceHours
              ? `${(report.summary.totalHours / 8).toFixed(2)} MD · ${fmtDur(report.summary.unpaidAbsenceHours)} unpaid absence not counted`
              : `${(report.summary.totalHours / 8).toFixed(2)} MD`,
          ],
          [
            'Client work',
            `${report.summary.billablePct.toFixed(0)}%`,
            `${fmtDur(report.summary.billableHours)} in period`,
          ],
          [
            'Committed',
            `${client.budget.toFixed(0)} MD`,
            'active budgeted projects',
          ],
        ]}
      />
      <Card title={`Projects in period · ${periodLabel}`}>
        {report.projects.length === 0 && (
          <p className="muted-text">No logged time in this period.</p>
        )}
        {report.projects.length > 0 && (
          <Table headers={['Project', 'Work type', 'Hours', 'MD', 'People']}>
            {report.projects.map(({ project, hours, peopleCount }) => {
              const navigable = canOpenProjectDetail(data, project.id);
              return (
                <tr
                  key={project.id}
                  className={navigable ? 'clickable' : undefined}
                  onClick={
                    navigable ? () => onOpenProject(project.id) : undefined
                  }
                >
                  <td>
                    <ProjectLabel project={project} />
                  </td>
                  <td>
                    {project.billable ? 'Client work' : 'Non-client work'}
                  </td>
                  <td className="strong">{fmtDur(hours)}</td>
                  <td>{(hours / 8).toFixed(2)}</td>
                  <td>{peopleCount}</td>
                </tr>
              );
            })}
          </Table>
        )}
      </Card>
    </>
  );
}
